import { helpers } from '@vuelidate/validators'

export default length =>
  helpers.withParams(
    { type: 'maxArrayLength', max: length },
    value => !Array.isArray(value) || value.length <= length,
  )
